module.exports = __webpack_public_path__ + "static/img/7.fcebff7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/3/eng/7.png
// module id = jZhq
// module chunks = 0